<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const statusCode = computed(() => props.error.statusCode || 500)

const heading = computed(() => {
  if (statusCode.value === 404) return 'Stránka nenalezena'
  if (statusCode.value === 403) return 'Přístup odepřen'
  if (statusCode.value >= 500) return 'Něco se pokazilo'
  return 'Chyba'
})

const description = computed(() => {
  if (statusCode.value === 404) {
    return 'Omlouváme se, ale požadovaná stránka neexistuje nebo byla přesunuta.'
  }
  if (statusCode.value === 403) {
    return 'K této stránce nemáte oprávnění.'
  }
  if (statusCode.value >= 500) {
    return 'Na serveru došlo k neočekávané chybě. Zkuste to prosím znovu.'
  }
  return props.error.message || 'Došlo k neočekávané chybě.'
})

function handleClearError() {
  clearError({ redirect: '/' })
}

function handleRetry() {
  clearError({ redirect: window.location.pathname })
}
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white">
    <div class="flex-1 container mx-auto px-4 py-16 flex items-center justify-center">
      <div class="max-w-md text-center">
        <div class="text-8xl font-bold text-gray-200 mb-4">
          {{ statusCode }}
        </div>

        <h1 class="text-2xl font-bold text-gray-900 mb-4">
          {{ heading }}
        </h1>

        <p class="text-gray-600 mb-8">
          {{ description }}
        </p>

        <div class="flex flex-col sm:flex-row gap-3 justify-center">
          <UButton
            color="primary"
            icon="i-lucide-home"
            @click="handleClearError"
          >
            Zpět na úvod
          </UButton>

          <UButton
            v-if="statusCode === 404"
            color="neutral"
            variant="outline"
            icon="i-lucide-search"
            @click="clearError({ redirect: '/veteriny' })"
          >
            Hledat veterináře
          </UButton>

          <UButton
            v-if="statusCode >= 500"
            color="neutral"
            variant="outline"
            icon="i-lucide-refresh-cw"
            @click="handleRetry"
          >
            Zkusit znovu
          </UButton>
        </div>
      </div>
    </div>
  </div>
</template>
